import InteractionPoint from "../InteractionPoint";
import React from "react";

export default function LdCenterInteractions() {
  return (
    <>

      <mesh position={[4.868, 1.4, -3.175]} rotation={[0, 0.419, 0]}>
        <InteractionPoint
          args={[0.15, 0.15, 0.15]}
          position={[0, 0, 0]}
          module={"videoTuto1"}
        ></InteractionPoint>
      </mesh>
      <mesh position={[5.475, 1.4, -1.675]} rotation={[0, 0.419, 0]}>
        <InteractionPoint
          args={[0.15, 0.15, 0.15]}
          position={[0, 0, 0]}
          module={"videoTuto2"}
        ></InteractionPoint>
      </mesh>
      <mesh position={[6.069, 1.4, -0.197]} rotation={[0, 0.419, 0]}>
        <InteractionPoint
          args={[0.15, 0.15, 0.15]}
          position={[0, 0, 0]}
          module={"videoTuto3"}
        ></InteractionPoint>
      </mesh>

      <mesh position={[5.516, 1.4, 1.667]} rotation={[0, 0.419, 0]}>
        <InteractionPoint
          args={[0.85, 0.85, 0.85]}
          position={[0, 0, 0]}
          module={"article1"}
          name="Scientific Publication"
        ></InteractionPoint>
      </mesh>
    </>
  );
}
